import { FC } from "react"
import { ChallengeSectionProps } from "../../pages/Challenge"
import RedeemCodesList from "../RedeemCodesList"

const ChallengeRedeemCodes: FC<ChallengeSectionProps> = ({ challenge }) => {
  return (
    <>
      <RedeemCodesList challenge={challenge} />
    </>
  )
}

export default ChallengeRedeemCodes